import * as Sentry from '@sentry/browser';

if (window.__sentry?.dsn) {
    Sentry.init({
        dsn: window.__sentry.dsn,
        release: window.__sentry.release,
        environment: window.__sentry.environment,
        integrations: [
            Sentry.browserTracingIntegration(),
        ],
        tracesSampleRate: 0.05,
    });
}

import './bootstrap';
import 'chart.js';
import Alpine from 'alpinejs';
import Chart from 'chart.js/auto';
window.Chart = Chart;
import '../../vendor/masmerise/livewire-toaster/resources/js';
import mask from '@alpinejs/mask'
import Clipboard from 'clipboard';

Alpine.plugin(mask)

// Vite — glob registers assets for bundling; return value intentionally unused
import.meta.glob([
    '../pdf/polisen/**',
    '../front/images/**',
    '../images/**'
]);

/**
 * Alpine.js component for the team location map.
 * Uses Leaflet + Nominatim to geocode the team address and render a static map tile.
 */
window.teamMap = function teamMap(query) {
    return {
        _map: null,
        _observer: null,
        init() {
            // Guard against Livewire DOM morphing re-triggering init
            // on an element Leaflet already owns
            if (this.$el._leaflet_id) {
                return;
            }
            fetch('https://nominatim.openstreetmap.org/search?format=json&q=' + encodeURIComponent(query) + '&limit=1')
                .then(response => response.json())
                .then(data => {
                    if (data.length > 0 && !this.$el._leaflet_id) {
                        const lat = parseFloat(data[0].lat);
                        const lon = parseFloat(data[0].lon);
                        this._map = L.map(this.$el, {
                            scrollWheelZoom: false,
                            dragging: false,
                            zoomControl: false,
                            attributionControl: true
                        }).setView([lat, lon], 14);
                        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                            attribution: '&copy; OpenStreetMap'
                        }).addTo(this._map);
                        L.marker([lat, lon]).addTo(this._map);
                        // Flux tab panels use display:none for inactive tabs,
                        // so Leaflet initialises on a 0×0 container.
                        // ResizeObserver fires when the panel becomes visible
                        // and invalidateSize() redraws tiles correctly.
                        this._observer = new ResizeObserver(() => {
                            if (this._map && this.$el.offsetWidth > 0) {
                                this._map.invalidateSize();
                            }
                        });
                        this._observer.observe(this.$el);
                    }
                });
        },
        destroy() {
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            if (this._map) {
                this._map.remove();
                this._map = null;
            }
        }
    };
};

/**
 * Alpine.js component for an arena map with known GPS coordinates.
 * Uses Leaflet to render a static map tile at the given lat/lon directly,
 * without any geocoding request.
 */
window.arenaMap = function arenaMap(lat, lon) {
    return {
        _map: null,
        _observer: null,
        init() {
            if (this.$el._leaflet_id) {
                return;
            }
            this._map = L.map(this.$el, {
                scrollWheelZoom: false,
                dragging: false,
                zoomControl: false,
                attributionControl: true
            }).setView([lat, lon], 14);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap'
            }).addTo(this._map);
            L.marker([lat, lon]).addTo(this._map);
            this._observer = new ResizeObserver(() => {
                if (this._map && this.$el.offsetWidth > 0) {
                    this._map.invalidateSize();
                }
            });
            this._observer.observe(this.$el);
        },
        destroy() {
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            if (this._map) {
                this._map.remove();
                this._map = null;
            }
        }
    };
};

let clipboard = new Clipboard('.copy-to-clipboard');

clipboard.on('success', function(e) {
    Toaster.success('Kopierat till urklipp:\n\n ' + e.text)
    e.clearSelection();
});

clipboard.on('error', function(e) {
    Toaster.error('Kunde inte kopiera texten....')

});